"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = require("events");

var _const = require("./const");

var _util = require("./util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const CONFIG = Symbol('core.config');
/** @type Core */

let SINGLETON = undefined;

class Core extends _events.EventEmitter {
  static singleton(initial) {
    if (SINGLETON) return SINGLETON;
    SINGLETON = new Core(initial);
    return SINGLETON;
  }

  constructor(initial = {}) {
    super();
    this[CONFIG] = {};
    this.setConfig(initial);
  }
  /**
   * 修改配置项
   * @param {object} config
   */


  setConfig(config) {
    Object.assign(this[CONFIG], config);
  }
  /**
   * 获取配置数据，如果有 name，则返回相应的插件配置
   * @param {string} [name] plugin name
   * @return {object}
   */


  getConfig(name) {
    if (!name) return this[CONFIG];
    return this[CONFIG][name] || {};
  }
  /**
   * 注册一个插件
   * @param {string} name plugin name
   * @param {Function} clazz plugin class
   * @param {object} [initial] plugin init props
   */


  register(name, clazz, initial = {}) {
    if (this[name] && (0, _util.isPluginInstance)(this[name])) {
      throw new Error("plugin ".concat(name, " has been registered."));
    }

    if (this[name]) {
      throw new Error('name can not be exist functions or properties.');
    }

    if (!(0, _util.isPluginExtended)(clazz)) {
      throw new Error('class must a Plugin');
    }

    const initConfig = this.getConfig(name);

    const nextConfig = _objectSpread({}, initConfig, {}, initial);

    this.setConfig({
      [name]: nextConfig
    });
    this[name] = new clazz(this, nextConfig);
    return this[name].init();
  }
  /**
   * 卸载一个插件
   * @param {string} name
   */


  unregister(name) {
    if (!this[name] || !(0, _util.isPluginInstance)(this[name])) {
      throw new Error("plugin ".concat(name, " does not exist."));
    }

    this[name].destroy();
    delete this[name];
  }

}

exports.default = Core;
Core[_const.CLASS_SYMBOL] = _const.CORE_CLASS;